import { Feedback } from '@/feedback';

$(document).ready(function() {
    Feedback.init();
});